import ContactForm from "./components/ContactForm";
import { Link } from "react-router-dom";
import { RiArrowDropRightLine } from "react-icons/ri";
import Section4 from "./components/Section4";
import MainLayout from "../../layouts/MainLayOut";

function Support() {
  return (
    <MainLayout>
      <div
        className=" flex flex-col text-slate-100"
        style={{
          background:
            "radial-gradient(circle, rgba(51, 65, 85, 1) 1%, rgba(2, 6, 23, 1) 92%)",
        }}>
        <main className="flex flex-col md:flex-row max-w-7xl mx-auto px-6 py-10 md:px-20 gap-12 flex-grow">
          {/* Support Info Section */}
          <section className="md:w-1/3 space-y-8 pr-6 md:border-r border-slate-700">
            <header className="text-slate-50 space-y-2">
              <h1 className="text-4xl font-extrabold">Support</h1>
              <nav className="flex items-center gap-1 text-slate-400 text-sm md:text-base">
                <Link to="/" className="hover:underline">
                  Home
                </Link>
                <RiArrowDropRightLine size={22} />
                <span>Support</span>
              </nav>
            </header>

            <div className="space-y-4 text-base leading-relaxed text-slate-300">
              <p>
                At{" "}
                <strong className="text-slate-50">
                  Token AI Labs Pvt. Ltd.
                </strong>
                , we're dedicated to providing the best support experience. If
                you have questions, need help with our products or services, or
                want to give feedback, please reach out.
              </p>
              <p>
                Fill out the form on the right with details so we can assist you
                effectively.
              </p>
              <p>
                Our Support Team will review your message and respond promptly.
                Thanks for contacting us!
              </p>
            </div>
          </section>

          {/* Contact Form Section */}
          <section className="md:w-2/3 bg-slate-800 bg-opacity-70 rounded-xl p-8 shadow-xl">
            <ContactForm />
          </section>
        </main>
        <div className=" w-full max-w-7xl mx-auto flex-grow pb-10">
          <Section4 />
        </div>
      </div>
    </MainLayout>
  );
}

export default Support;
